import MultiLingualContent from "./multilingualContent";
import React from "react";

export const translations = {
    english: {
        home: "Home",
        about: "About",
        tboard: "Dashboard",
        sourcenbalance: "Source & Balance",
        balance: "Balance",
        indicator: "Indicator",
        sig:'GIS Portail',
        login: "Login",
        actu: "News",
        contact: "Contact",
        seemore: "See more",
        uselink: "Use link",
        socialnetwork: "Ours networks",
        submit: "Submit",
        year: "Year",
        nodata: "No data available",
        ind1: "Share of RE in electricity production (%)",
        ind2: 'Household access to electricity (%)',
        siecedeao: 'ECOWAS-EIS',
        sankey:'Energy flow',
        menu:'Menu',
        simplbalancedata:'Simple balance',
        detbalancedata:'Detailled balance',
        combfgazmdata:'Mineral coal and manufactured gas',
        elecqdata:'Electricity and heat',
        enrbiomassedata:'Renewable energies and biomass',
        gaznaturaldata:'Natural gas',
        petroledata:'Oil',
        afrec:'AFREC',
        copyrigth:'©2021 - 2022, All rights reserved',
        term_condition:'Terms & Conditions',
        support: "With technical support of"
    },
    french: {
        home: "Accueil",
        about: "A propos",
        tboard: "Tableau de board",
        sourcenbalance: "Source & Bilan",
        balance: "Bilan",
        indicator: "Indicateurs",
        sig:'Portail SIG',
        login: "Connexion",
        actu: "Actualités",
        contact: "Contact",
        seemore: "Voir plus",
        uselink: "Lien utiles",
        socialnetwork: "Nos réseaux",
        submit: "Soumettre",
        year: "Année",
        nodata: "Aucune donnée disponible",
        ind1: "Part des EnR dans la production d'électricité (%)",
        ind2: "Taux d'accès des ménages à l'électricité (%)",
        siecedeao:'SIE-CEDEAO',
        sankey:'Flux énergétique',
        menu:'Menu',
        simplbalancedata:'Bilan Agrégé',
        detbalancedata:'Bilan désagrégé',
        combfgazmdata:'Charbon minéral et gaz manufacturé',
        elecqdata:'Electricité et chaleur',
        enrbiomassedata:'Energies renouvelables et biomasse',
        gaznaturaldata:'Gaz naturel',
        petroledata:'Pétrole',
        afrec:'AFREC',
        copyrigth:'©2021 – 2022, Tous droits réservés',
        term_condition:'Termes & Conditions Générales d’utilisation',
        support: "Avec le soutien technique de"
    },
    portuguais: {
        home: "home",
        about: "Uma proposta",
        tboard: "Quadro de bordo",
        sourcenbalance: "Fonte e Bilan",
        balance: "Bilan",
        indicator: "Indicadores",
        sig:'Portal SIG',
        login: "Ligação",
        actu: "Notícias",
        contact: "Contacto",
        seemore: "Ver mais",
        uselink: "Ligações úteis",
        socialnetwork: "As nossas redes",
        submit: "Enviar",
        year: "Ano",
        nodata: "Não existem dados disponíveis",
        ind1: "Quota de energias renováveis na produção de eletricidade (%)",
        ind2: "Acesso do agregado familiar à eletricidade (%)",
        siecedeao:'SIE-CEDEAO',
        sankey:'Fluxo de energia',
        menu:'Menu',
        simplbalancedata:'Balanço agregado',
        detbalancedata:'Balanço desagregado',
        combfgazmdata:'Carvão mineral e gás manufaturado',
        elecqdata:'Eletricidade e calor',
        enrbiomassedata:'Energias renováveis e biomassa',
        gaznaturaldata:'Gás natural',
        petroledata:'Óleo',
        afrec:'AFREC',
        copyrigth:'©2021 - 2022, Todos os direitos reservados',
        term_condition:'Termos e condições',
        support: "Com o apoio técnico de"
    },
};